import { createSlice } from '@reduxjs/toolkit'


import { SAML_DEFAULT_SETTINGS, SAML_INITIAL_STEP } from './constants'
import { calculateCurrentStep } from './helpers'
import { INITIAL_SAML_TEST_SETTINGS } from './test_saml_connection/constants'
import {
  applyTestSamlSettings,
  destroySamlSsoSettings,
  fetchAggregateSsoSettings,
  saveSamlSsoSettings,
  saveTestSamlSettings
} from './thunks'
import { reload } from '../../../actions/core/navigation'

const initialState = {
  isLoading: false,
  currentStep: SAML_INITIAL_STEP,
  testSamlSettings: { ...INITIAL_SAML_TEST_SETTINGS },
  samlSettings: { ...SAML_DEFAULT_SETTINGS },
  deleteDialog: {
    isLoading: false,
    isDialogOpen: false,
  }
}

const slice = createSlice({
  name: 'samlSsoSettings',
  initialState,
  reducers: {
    openTestSamlConnectionModal: (state) => {
      state.testSamlSettings.isModalOpen = true
    },
    resetTestSamlSettings: (state) => {
      state.testSamlSettings = { ...INITIAL_SAML_TEST_SETTINGS }
    },
    selectStep: (state, { payload }) => {
      state.currentStep = payload
    },
    setCurrentSsoStep: (state, { payload }) => {
      state.currentStep = calculateCurrentStep(payload)
    },
    setSamlSsoSettings: (state, { payload }) => {
      state.samlSettings = { ...state.samlSettings, ...payload }
    },
    setTestSamlSettings: (state, { payload }) => {
      state.testSamlSettings = { ...state.testSamlSettings, ...payload }
    },
    setDeleteDialogOpen: (state, { payload }) => {
      state.deleteDialog.isDialogOpen = payload
    },
    setDeleteDialogLoading: (state, { payload }) => {
      state.deleteDialog.isLoading = payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAggregateSsoSettings.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(fetchAggregateSsoSettings.fulfilled, (state, { payload }) => {
      state.isLoading = false
      state.currentStep = calculateCurrentStep(payload.state)
      state.samlSettings = payload
    })
    builder.addCase(fetchAggregateSsoSettings.rejected, (state) => {
      state.isLoading = false
    })
    builder.addCase(saveSamlSsoSettings.fulfilled, (state, { payload }) => {
      state.currentStep = calculateCurrentStep(payload.state)
      state.samlSettings = payload
    })
    builder.addCase(saveSamlSsoSettings.rejected, (state, { payload }) => {
      state.errors = payload
    })
    builder.addCase(destroySamlSsoSettings.pending, (state) => {
      state.deleteDialog.isLoading = true
    })
    builder.addCase(destroySamlSsoSettings.fulfilled, (state) => {
      state.deleteDialog = { ...initialState.deleteDialog }
      reload()
    })
    builder.addCase(destroySamlSsoSettings.rejected, (state) => {
      state.deleteDialog.isLoading = false
    })
    builder.addCase(saveTestSamlSettings.fulfilled, (state, { payload }) => {
      state.testSamlSettings = { ...state.testSamlSettings, ...payload }
    })
    builder.addCase(saveTestSamlSettings.rejected, (state, { payload }) => {
      state.testSamlSettings.errors = payload
    })
    builder.addCase(applyTestSamlSettings.pending, (state) => {
      state.testSamlSettings.isLoading = true
    })
    builder.addCase(applyTestSamlSettings.fulfilled, (state, { payload }) => {
      state.testSamlSettings = { ...INITIAL_SAML_TEST_SETTINGS }
      state.samlSettings = payload
    })
    builder.addCase(applyTestSamlSettings.rejected, (state) => {
      state.testSamlSettings.isLoading = false
    })
  }
})


export const { reducer } = slice

export const {
  openTestSamlConnectionModal,
  resetTestSamlSettings,
  selectStep,
  setCurrentSsoStep,
  setDeleteDialogOpen,
  setSamlSsoSettings,
  setTestSamlSettings,
} = slice.actions
